import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';

export class RequirementsCount extends Field {
  static attributesForModel() {
    return ['requirementsCount'];
  }

  get title() {
    return `${terminology('Requirements')} count`;
  }

  exampleContents(): FieldContentsData {
    return {
      text: `2 ${terminology('Requirement', {
        isPlural: true,
      })}`,
    };
  }

  contentsForRecord(record): FieldContentsData {
    return {
      text: `${record.requirementsCount} ${terminology('Requirement', {
        isPlural: record.requirementsCount !== 1,
      })}`,
    };
  }
}
